import {
    CLEAR_USER, EMPTY_ACCOUNTS,
    FETCH_COMPANY, FETCH_COMPANY_SUCCESS, FETCH_COMPANY_FAILURE,
    FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURE,
    SAVE_AVATAR, SAVE_AVATAR_SUCCESS, SAVE_AVATAR_FAILURE,
    SAVE_COMPANY, SAVE_COMPANY_SUCCESS, SAVE_COMPANY_FAILURE,
    SAVE_PAYMENT_METHOD, SAVE_PAYMENT_METHOD_SUCCESS, SAVE_PAYMENT_METHOD_FAILURE,
    SAVE_SUBSCRIPTION, SAVE_SUBSCRIPTION_SUCCESS, SAVE_SUBSCRIPTION_FAILURE,
    SAVE_USER, SAVE_USER_FAILURE, SAVE_USER_SUCCESS,
    SET_COMPANY, SET_USER, UPDATE_ACCOUNTS
} from './constants';

import clone from 'clone';

const initialState = {
    company: {},
    user: {},
    isFetching: false,
    isSavingAvatar: false,
    isSavingCompany: false,
    isSavingPaymentMethod: false,
    isSavingUser: false,
    error: {},
    savePaymentMethodError: {}
};

function accountsReducer(state = clone(initialState), action) {
    switch(action.type) {
        case CLEAR_USER:
            return Object.assign({}, state, {
                user: {}
            });
        case EMPTY_ACCOUNTS:
            return clone(initialState);
        case FETCH_COMPANY:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_COMPANY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                company: action.data,
            });
        case FETCH_COMPANY_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_USER:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_USER_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                user: action.data,
            });
        case FETCH_USER_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SAVE_AVATAR:
            return Object.assign({}, state, {
                isSavingAvatar: true,
                error: {}
            });
        case SAVE_AVATAR_SUCCESS:
            return Object.assign({}, state, {
                isSavingAvatar: false
            });
        case SAVE_AVATAR_FAILURE:
            return Object.assign({}, state, {
                isSavingAvatar: false,
                error: action.error
            });
        case SAVE_COMPANY:
            return Object.assign({}, state, {
                isSavingCompany: true,
                error: {}
            });
        case SAVE_COMPANY_SUCCESS:
            return Object.assign({}, state, {
                isSavingCompany: false,
                company: action.data
            });
        case SAVE_COMPANY_FAILURE:
            return Object.assign({}, state, {
                isSavingCompany: false,
                error: action.error
            });
        case SAVE_PAYMENT_METHOD:
            return Object.assign({}, state, {
                isSavingPaymentMethod: true,
                savePaymentMethodError: {}
            });
        case SAVE_PAYMENT_METHOD_SUCCESS:
            return Object.assign({}, state, {
                isSavingPaymentMethod: false
            });
        case SAVE_PAYMENT_METHOD_FAILURE:
            return Object.assign({}, state, {
                isSavingPaymentMethod: false,
                savePaymentMethodError: action.error
            });
        case SAVE_SUBSCRIPTION:
            return Object.assign({}, state, {
                isSavingSubscription: true,
                saveSubscriptionError: {}
            });
        case SAVE_SUBSCRIPTION_SUCCESS:
            return Object.assign({}, state, {
                isSavingSubscription: false,
                company: action.data
            });
        case SAVE_SUBSCRIPTION_FAILURE:
            return Object.assign({}, state, {
                isSavingSubscription: false,
                saveSubscriptionError: action.error
            });
        case SAVE_USER:
            return Object.assign({}, state, {
                isSavingUser: true,
                error: {}
            });
        case SAVE_USER_SUCCESS:
            return Object.assign({}, state, {
                isSavingUser: false,
                user: action.data
            });
        case SAVE_USER_FAILURE:
            return Object.assign({}, state, {
                isSavingUser: false,
                error: action.error
            });
        case SET_COMPANY:
            return Object.assign({}, state, {
                company: action.data
            });
        case SET_USER:
            return Object.assign({}, state, {
                user: action.data
            });
        case UPDATE_ACCOUNTS:
            return action.data;
        default:
            return state;
    }
}

export default accountsReducer;



// WEBPACK FOOTER //
// ./src/containers/Accounts/store/reducers.js